module.exports = {
  "argument": [
    {
      "name": "argument",
      "type": [
        "Function"
      ],
      "description": {
        "en": "The function to invoke on window resize",
        "ja": "ウィンドウのサイズ変更時に呼び出す関数",
        "zh-Hans": "调整窗口大小时调用的函数"
      }
    }
  ],
  "modifiers": [
    {
      "name": "quiet",
      "default": "false",
      "type": [
        "boolean"
      ],
      "description": {
        "en": "Will **not** automatically invoke the provided callback on bind.",
        "ja": "bindで指定されたコールバックを自動的に呼び出すことは**ありません**。",
        "zh-Hans": "将 **不会** 在绑定时自动调用提供的回调函数"
      }
    }
  ],
  "props": [],
  "name": "v-resize",
  "directive": true
}